module.exports = __webpack_public_path__ + "static/media/lamina152.1a02ac66.png";